<template>
  <el-form
    class="activity-form"
    :model="elementForm"
    ref="form"
  >
    <div class="row">
      <div class="col" :class="{'col-xl-9 col-12': displayActivityLog }">
        <div class="row activity-form__boxes">
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2">
            <div class="activity-item__status-section" :class="classShipped">
              <el-form-item
                prop="shipped"
                class="material-style"
              >
                <el-checkbox
                  v-model="form.shipped"
                  @change="autoSave('shipped', { payloadData: { shippedDate: new Date() } })"
                >
                  {{L10n('shipped-to-shop')}}
                </el-checkbox>
              </el-form-item>
              <el-form-item
                :label="L10n('shipped-date')"
                prop="shippedDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.shippedDate"
                  @change="autoSave('shippedDate')"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2" >
            <div class="activity-item__status-section" :class="classQuoteReceived">
              <el-form-item
                prop="quoteReceived"
                class="material-style"
              >
                <el-checkbox
                  v-model="form.quoteReceived"
                  @change="autoSave('quoteReceived', { payloadData: { quoteReceivedDate: new Date() } })"
                >
                  {{L10n('quote-received')}}
                </el-checkbox>
              </el-form-item>
              <el-form-item
                :label="L10n('quote-received-date')"
                prop="quoteReceivedDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.quoteReceivedDate"
                  @change="autoSave('quoteReceivedDate')"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2">
            <div class="activity-item__status-section" :class="classQuoteApproved">
              <el-form-item
                prop="quoteApproved"
                class="material-style"
              >
                <el-checkbox
                  v-model="form.quoteApproved"
                  @change="autoSave('quoteApproved', { payloadData: { quoteApprovedDate: new Date() } })"
                >
                  {{L10n('quote-approved')}}
                </el-checkbox>
              </el-form-item>
              <el-form-item
                :label="L10n('quote-approved-date')"
                prop="quoteApprovedDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.quoteApprovedDate"
                  @change="autoSave('quoteApprovedDate')"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2">
            <div class="activity-item__status-section" :class="classUnitShipped">
              <el-form-item
                prop="unitShipped"
                class="material-style"
              >
                <el-checkbox
                  v-model="form.unitShipped"
                  @change="autoSave('unitShipped', { payloadData: { unitShippedDate: new Date() } })"
                >
                  {{L10n('ship-rcvd-by-bax')}}
                </el-checkbox>
              </el-form-item>
              <el-form-item
                :label="L10n('ship-rcvd-by-bax-date')"
                prop="unit-shipped-date"
                class="material-style"
              >
                <date-picker
                  v-model="form.unitShippedDate"
                  @change="autoSave('unitShippedDate')"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2">
            <div class="activity-item__status-section" :class="classStandBy">
              <el-form-item
                :label="L10n('stand-by')"
                prop="standby"
                class="material-style"
              >
                <select-response
                  :model.sync="form.standby"
                  :data="sourceStandBy"
                  @on-change="(id, data) => autoSave('standby', { label: data && data.title, payloadData: { standbyDate: new Date() }})"
                >
                </select-response>
              </el-form-item>
              <el-form-item
                :label="L10n('stand-by-date')"
                prop="standbyDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.standbyDate"
                  @change="autoSave('standbyDate')"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6 col-12 p-2">
            <div class="activity-item__status-section" :class="classConfirmedEdd">
              <el-form-item
                :label="L10n('confirmed-edd')"
                class="material-style"
              >
                <date-picker
                  v-model="form.estimatedDeliveryDate"
                  @change="autoSave('estimatedDeliveryDate', configRFQ2s)"
                >
                </date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-4">
            <el-form-item
              :label="L10n('order-phase')"
              prop="orderPhase"
              class="material-style"
            >
              <select-response
                :model.sync="form.orderPhaseID"
                @on-change="(id, data) => autoSave('orderPhaseID', { label: data && data.title, payloadData: { phaseDate: new Date() } })"
                :isLoading="dataSourceOrderPhase.loading"
                :data="dataSourceOrderPhase.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-4">
            <el-form-item
              :label="L10n('phase-date')"
              prop="phaseDate"
              class="material-style"
            >
              <date-picker
                v-model="form.phaseDate"
                @change="autoSave('phaseDate')"
              ></date-picker>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-4">
            <el-form-item
              :label="L10n('phase-employee')"
              prop="phasePersonInChargeEmployeeID"
              class="material-style"
            >
              <select-response
                :model.sync="form.phasePersonInChargeEmployeeID"
                @on-change="(id, data) => autoSave('phasePersonInChargeEmployeeID', { label: data && data.title })"
                :isLoading="dataSourceEmployee.loading"
                :data="dataSourceEmployee.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-6">
            <el-form-item
              :label="L10n('received-date')"
              class="material-style"
            >
              <date-picker
                v-model="form.receivedDate"
                @change="autoSave('receivedDate', configRFQ2s)"
              ></date-picker>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-6">
            <el-form-item
              :label="L10n('reminder-date')"
              class="material-style"
              prop="reminderDate"
            >
              <date-picker
                v-model="form.reminderDate"
                @change="autoSave('reminderDate')"
              >
              </date-picker>
            </el-form-item>
          </div>
          <div class="col-lg-6 col-md-8">
            <el-form-item
              :label="L10n('subject')"
              class="material-style"
              prop="subject"
              :rules="getValidationRule('required')"
              :error="subjectError"
            >
              <select-response
                :model.sync="subject"
                :fields="{ id: 'subject', title: 'subject' }"
                :isLoading="dataSourceCompanyRemarks.loading"
                :data="dataSourceCompanyRemarks.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-4">
            <el-form-item
              data-filed="true"
              class="material-style"
            >
              <ui-button
                class="btn btn-size-s btn-mobile-full"
                @click="onStatusEmail"
              >
                {{L10n('status-request-email')}}
              </ui-button>
            </el-form-item>
          </div>
          <div class="col-12 activity-form__user-actions">
            <ui-button
              class="btn btn-size-s btn-mobile-full"
              :disabled="disabledNewInstruction"
              @click="onNewInstruction"
            >
              {{L10n('send-new-instruction-to-support')}}
            </ui-button>
            <slot name="user-actions"></slot>
          </div>
        </div>
      </div>
      <div :class="{ 'col-xl-3 col-12': displayActivityLog}">
        <div v-if="displayActivityLog">
          <slot name="log-list"></slot>
          <div class="p-4 mt-3">
            <el-form-item
              :label="L10n('last-info')"
              class="material-style"
              prop="lastInfo"
            >
              <el-input
                type="textarea"
                :rows="4"
                :value="form.lastInfo"
                @input="form.lastInfo = valueTrimLeft($event)"
                @change="autoSave('lastInfo')"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <vertical-collapse v-else>
          <template v-slot:title="{ toggle}">
            <ui-button
              style="height: 100%"
              class="btn btn-size-s"
              :label="L10n('activity-log')"
              isVertical
              @click.stop.prevent="toggle"
            />
          </template>
          <template>
            <slot name="log-list"></slot>
            <div class="p-4 mt-3">
              <el-form-item
                :label="L10n('last-info')"
                class="material-style"
                prop="lastInfo"
              >
                <el-input
                  type="textarea"
                  :rows="4"
                  :value="form.lastInfo"
                  @input="form.lastInfo = valueTrimLeft($event)"
                  @change="autoSave('lastInfo')"
                >
                </el-input>
              </el-form-item>
            </div>
          </template>
        </vertical-collapse>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'ActivityForm',
  mixins: [Form],
  components: {
    'vertical-collapse': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/VerticalCollapse')
  },
  props: {
    displayActivityLog: { type: Boolean, required: true },
    disabledNewInstruction: { type: Boolean, default: true },
    subjectError: { required: true }
  },
  data () {
    return {
      subject: ''
    }
  },
  computed: {
    elementForm () {
      return { ...this.form, subject: this.subject }
    },
    dataSourceOrderPhase () {
      return this.API('orderPhases/GetAllDynamic?select=id,title&filter=!title.startsWith("Z_")&orderBy=title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    dataSourceCompanyRemarks () {
      return this.API('CompanyRemarkSubjects/GetAllDynamic?Select=subject&Filter=tableIndex==6&OrderBy=subject')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    sourceStandBy () {
      return [
        { id: 'sourcing-parts', title: this.L10n('sourcing-parts') },
        { id: 'standby', title: this.L10n('standby') },
        { id: 'pending-payment', title: this.L10n('pending-payment') }
      ]
    },
    classShipped () {
      return {
        'border-x-green': this.form.shipped,
        'border-x-orange': !this.form.shipped
      }
    },
    classQuoteReceived () {
      const { quoteReceived, quoteReceivedDate, shippedDate } = this.form
      const _date = quoteReceivedDate || new Date()

      const days = this.$moment(_date).diff(shippedDate, 'days')

      return {
        'border-x-green': quoteReceived,
        'border-x-orange': !quoteReceived && days >= 10
      }
    },
    classQuoteApproved () {
      const { quoteReceivedDate, quoteApprovedDate, quoteApproved } = this.form
      const _date = quoteApprovedDate || new Date()

      const days = this.$moment(_date).diff(quoteReceivedDate, 'days')

      return {
        'border-x-green': quoteApproved,
        'border-x-red': !quoteApproved && days >= 21,
        'border-x-orange': !quoteApproved && days >= 7 && days < 21
      }
    },
    classUnitShipped () {
      return {
        'border-x-green': this.form.unitShippedDate,
        'border-x-none': !this.form.unitShippedDate
      }
    },
    classStandBy () {
      return {
        'border-x-orange': this.form.standbyDate,
        'border-x-none': !this.form.standbyDate
      }
    },
    classConfirmedEdd () {
      const { estimatedDeliveryDate } = this.form
      const dif = this.$moment(estimatedDeliveryDate).diff(new Date())
      return {
        'border-x-red': dif < 0,
        'border-x-orange': !estimatedDeliveryDate
      }
    },
    configRFQ2s () {
      return { api: `RFQ2s/Patch/${this.form.rfq2ID}` }
    }
  },
  methods: {
    onStatusEmail () {
      this.$emit('onStatusEmail', { subject: this.subject })
    },
    onNewInstruction () {
      this.$emit('onNewInstruction', { subject: this.subject })
    }
  }
}
</script>
